import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../../enum/constant";

const UserBankinfo = () => {
  const [bankInfo, setBankInfo] = useState(null); // Store the bank info
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Get logged-in user ID from localStorage
    const userId = localStorage.getItem("userId");

    if (userId) {
      // Fetch the existing bank info when the component mounts
      const fetchBankInfo = async () => {
        try {
          const base = baseUrl;
          const response = await axios.get(
            `${base}api/bank-info/show/${userId}`
          );

          if (response.data) {
            setBankInfo(response.data); // Set bank info to state
          } else {
            setMessage("No bank info found.");
          }
        } catch (error) {
          console.error("Error fetching bank info:", error);
          setMessage("Failed to fetch bank info.");
        }
      };

      fetchBankInfo();
    } else {
      // Handle case where no user is logged in
      setMessage("User is not logged in.");
    }
  }, []); // Empty dependency array ensures the effect runs only once

  return (
    <>
      {
        bankInfo ? (
          <div className="col-md-6">
            <div className="inner-box">
              <h3>Bank details</h3>
              <div className="b-details-box bg-gray100">
                <div className="box">
                  <span>Company name</span>
                  <p>{bankInfo.company_name}</p>
                  <span>Company address</span>
                  <p>{bankInfo.company_address}</p>
                </div>
                <hr />
                <div className="box">
                  <span>Bank name</span>
                  <p>{bankInfo.bank_name}</p>
                  <span>Bank address</span>
                  <p>{bankInfo.bank_address}</p>
                  <span>Account number</span>
                  <p>{bankInfo.account_number}</p>
                  <span>Reference field</span>
                  <p>{bankInfo.reference_field}</p>
                  <span>BIC/Swift</span>
                  <p>{bankInfo.bic_swift}</p>
                  <span>Supported payments</span>
                  <p>{bankInfo.supported_payments}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>.</p>
        )
      }
    </>
  );
};

export default UserBankinfo;
